// extracted by mini-css-extract-plugin
module.exports = {"cardbox":"WealthLevels_cardbox_1JA5v"};